<ng-container *ngFor="let row of videoRows">
  <sv-video-list-row #ele [class.focus]="ele.isFocused" [videos]="row"></sv-video-list-row>
</ng-container>
